import { MediaBelowSmall, MediaMediumAndAbove, MediaSmallAndAbove, Spacing } from '@lichtblick/theme';
import styled, { css } from 'styled-components';
import { StyledBoxCTALink } from '../../atoms/BoxCTA/BoxCTA.styles';
import { Chip } from '../../atoms/Chip/Chip';
import { Headline } from '../../atoms/Headline/Headline';
import { Text } from '../../atoms/Text/Text';
import { StyledTextCTALink } from '../../atoms/TextCTA/TextCTA.styles';
export const StyledTextIntro = styled.div`
  ${({ $isCenteredMobile })=>$isCenteredMobile && css`
      ${MediaBelowSmall} {
        text-align: center;
      }
    `}

  ${({ $isCenteredDesktop })=>$isCenteredDesktop && css`
      ${MediaSmallAndAbove} {
        text-align: center;
      }
    `}

  ${StyledBoxCTALink}, ${StyledTextCTALink} {
    margin-top: ${Spacing.Xs};
  }
`;
export const TextIntroChip = styled(Chip)`
  margin-bottom: ${Spacing.Xxs};

  @media ${MediaMediumAndAbove} {
    margin-bottom: ${Spacing.Xs};
  }
`;
export const TextIntroHeadline = styled(Headline)`
  &:not(:only-child) {
    margin-bottom: ${Spacing.Xxs};
  }
`;
export const TextIntroText = styled(Text)`
  ${MediaMediumAndAbove} {
    ${({ $isOStageSplit })=>$isOStageSplit && css`
        max-width: calc(${100 / 12 * 11}% - 2rem);
      `}
  }
`;

//# sourceMappingURL=TextIntro.styles.js.map